<!-- Content Header (Page header) -->
<section class="content-header">
  <div class="container-fluid">
      <div class="row mb-2">
          <div class="col-sm-6">
              <h1>{{course?.from?.name}}-{{course?.to?.name}}</h1>
          </div>
          <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item"><a href="/admin">Home</a></li>
                  <li class="breadcrumb-item active">{{course?.from?.name}}-{{course?.to?.name}}</li>
              </ol>
          </div>
      </div>
  </div>
  <!-- /.container-fluid -->
</section>

<section class="content">
  <!-- Default box -->
  <div class="container-fluid">
      <div class="card">
          <div class="card-header">
              <h3 class="card-title">Keyword Types <button class="btn btn-primary pull-right" (click)="openNwyKeywordType()">+Add New</button></h3>

             
          </div>
          <div class="card-body">
            

            <table class="table table-bordered">
              <thead>
              <tr>
                <th>Name</th>
               
                <th>İşlemler</th>
              </tr>
              </thead>  
              <tbody>
                <tr *ngFor="let lang of keywordTypes" >
                  <td>{{lang.name}}</td>
                
              
             
              
                  <td> 
                  
                     <button class="btn btn-icon btn-pure info" (click)="editType(lang)" title="düzenle"><i class="fa fa-edit"></i> </button>
                     |  
                     <button class="btn btn-icon btn-pure danger" (click)="deleteType(lang.id)" title="sil"><i class="fa fa-trash"></i></button></td>
              
                </tr>
              </tbody>
            
            </table>
            
                               
                      



          </div>
          <!-- /.card-body -->
          <div class="card-footer"></div>
          <!-- /.card-footer-->
      </div>
  </div>
  <!-- /.card -->
</section>
<!-- /.content -->

<!-- Main content -->
<section class="content">
  <!-- Default box -->
  <div class="container-fluid">
      <div class="card">
          <div class="card-header">
              <h3 class="card-title">Seviyeler <button class="btn btn-primary pull-right" (click)="openSaveModal()">+Yeni Ekle</button></h3>

             
          </div>
          <div class="card-body">
            

            <table class="table table-bordered">
              <thead>
              <tr>
                <th>Sıra</th>
                <th>İkon</th>
                <th>Seviye</th>
                <th>Başlık</th>
                <th>Açıklama</th>
               
                <th>İşlemler</th>
              </tr>
              </thead>  
              <tbody>
                <tr *ngFor="let lang of course?.levels" >
                  <td>{{lang.order}}</td>
                  <td ><img src="{{lang.iconUrl}}" height="30"></td>
                  <td>{{lang.name}}</td>
                  <td>{{lang.header}}</td>
                  <td>{{lang.description}}</td>
              
             
              
                  <td> 
                     <button class="btn btn-icon btn-pure success" (click)="detail(lang.id)" title="detay"><i class="fa fa-info"></i> </button>
                     |  
                     <button class="btn btn-icon btn-pure info" (click)="edit(lang)" title="düzenle"><i class="fa fa-edit"></i> </button>
                     |  
                     <button class="btn btn-icon btn-pure danger" (click)="delete(lang.id)" title="sil"><i class="fa fa-trash"></i></button></td>
              
                </tr>
              </tbody>
            
            </table>
            
                               
                      



          </div>
          <!-- /.card-body -->
          <div class="card-footer"></div>
          <!-- /.card-footer-->
      </div>
  </div>
  <!-- /.card -->
</section>
<!-- /.content -->
